<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <tab-header :transDataSet="transDate"></tab-header>
    <div class="appContext withTab">
      <form @submit.prevent="submitForm">
        <div class="container">
          <div class="area_wrap">
            <div class="title_wrap pdSide-20 mb-0">
              <h3>전화예약상담 신청 절차</h3>
            </div>
            <div class="step_wrap">
              <div class="sw_item">
                <div class="item_number red">
                  <p>01</p>
                </div>
                <div class="item_content">
                  <p>전화예약상담 신청</p>
                </div>
              </div>
              <div class="sw_item">
                <div class="item_number black">
                  <p>02</p>
                </div>
                <div class="item_content">
                  <p>상담원 통화</p>
                </div>
              </div>
              <div class="sw_item">
                <div class="item_number red">
                  <p>03</p>
                </div>
                <div class="item_content">
                  <p>진료의사 및 일정 상담 후 예약</p>
                </div>
              </div>
              <div class="sw_item">
                <div class="item_number black">
                  <p>04</p>
                </div>
                <div class="item_content">
                  <p>예약일 방문 및 진료</p>
                </div>
              </div>
            </div>
          </div>
          <div class="area_wrap pdSide-20">
            <div class="text_wrap tel">
              <div class="tw_item">
                <p>이름, 전화번호, 요청사항을 입력해 주시면</p>
                <p>상담시간에 전화 연락 드리겠습니다.</p>
              </div>
              <div class="tw_item">
                <p class="asterisk">상담시간 : 평일 09:00 - 17:30</p>
                <p>토요일 09:00 - 12:30 (공휴일 제외)</p>
                <p class="asterisk">상담 전화 연결 2회 이상 실패할 경우</p>
                <p>전화예약 상담 신청이 자동 취소됩니다.</p>
              </div>
            </div>
            <div class="title_wrap">
              <h3>개인정보 입력</h3>
              <p class="warn">필수입력정보입니다.</p>
            </div>
            <div class="aw_context tel userInput">
              <div class="warnSpace">
                <p class="warn" v-text="form.userName.errorTxt" v-if="form.userName.hasError"></p>
              </div>
              <div class="article require" :class="{errorLaise : form.userName.hasError}">
                <div class="inputHeader">
                  <p>이름</p>
                </div>
                <input
                  type="text"
                  id="nameStored"
                  placeholder="이름을 입력해주세요."
                  v-model="form.userName.value"
                  maxlength="21"
                  @keyup="blurName()"
                  class="userInput"
                />
              </div>
              <div class="warnSpace">
                <p class="warn" v-text="form.tel.errorTxt" v-if="form.tel.hasError"></p>
              </div>
              <div class="article require" :class="{errorLaise : form.tel.hasError}">
                <div class="inputHeader">
                  <p>전화번호</p>
                </div>
                <input
                  type="text"
                  id="telStored"
                  v-model="form.tel.value"
                  maxlength="13"
                  @keyup="blurTel()"
                  @input="formatPhoneNumber(form.tel.value)"
                  placeholder="전화번호를 입력해주세요."
                />
              </div>
              <div
                class="article require mt-15"
                :class="{errorLaise : form.visitPathCode.hasError}"
              >
                <div class="inputHeader">
                  <p>내원사유</p>
                </div>
                <div class="inputBtn">
                  <p v-if="comingValue" v-text="this.transContent"></p>
                  <button type="button" @click="goComing()" v-if="!comingValue">선택</button>
                  <button type="button" @click="goComing()" v-else>변경</button>
                </div>
              </div>
              <div class="mt-24 mb-14 width-100">
                <div
                  class="article require full"
                  :class="{errorLaise : form.requestContents.hasError}"
                >
                  <div class="inputHeader">
                    <p>요청사항</p>
                    <span
                      class="warn"
                      v-text="form.requestContents.errorTxt"
                      v-if="form.requestContents.hasError"
                    ></span>
                  </div>
                  <textarea
                    type="text"
                    placeholder="요청사항을 입력해주세요. (상담가능한 시간을 적어주시면 연락드립니다)"
                    v-model="form.requestContents.value"
                    maxlength="500"
                    @keyup="blurText()"
                  />
                </div>
              </div>
            </div>

            <div class="title_wrap">
              <h3>방문 경로 선택</h3>
            </div>
            <div class="check_wrap">
              <div class="cw_item" v-for="(v, i) in getVisitList" :key="i">
                <input
                  type="checkbox"
                  :value="v.id"
                  :id="v.id*100"
                  v-model="form.visitPathCode.value"
                />
                <label :for="v.id*100">
                  <span class="cw_checkImg"></span>
                  <h3>{{v.content}}</h3>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div
          class="btnWrap"
          :class="{visible : form.userName.flag && form.tel.flag && form.requestContents.flag}"
        >
          <button type="submit">전화상담 신청</button>
        </div>
      </form>
    </div>
    <add-popup v-if="checkPopup" :popupSet="popupSet" />
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppSidebar from "@/components/AppSidebar";
import TabHeader from "@/components/TabHeader";
import AddPopup from "@/components/AddPopup";
import errorParser from "@/utils/error-parser";
import { getCookie } from "@/utils/cookieNew";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
// import EventBus from '@/utils/bus'
// import { Dert } from '@/assets/js/thanQAlert'

export default {
  data() {
    return {
      popupSet: {
        title: "",
        modalImg: "alert_cn.svg",
        content: "",
        confirmBtnText: "확인",
        count: "single",
        closeType: "close",
      },
      transDate: {
        headerName: "전화예약상담",
        pos: "2",
        chapter: 2,
        prevUrl: "/telReservation_step1",
      },
      comingValue: false,
      form: {
        userName: {
          value: "",
          flag: false,
          hasError: false,
          errorTxt: "필수 항목입니다.",
        },
        tel: {
          value: "",
          flag: false,
          hasError: false,
          errorTxt: "필수 항목입니다.",
        },
        requestContents: {
          value: "",
          flag: false,
          hasError: false,
          errorTxt: "필수 항목입니다.",
        },
        visitPathCode: {
          value: [],
          flag: false,
          hasError: false,
          errorTxt: "필수 항목입니다.",
        },
        comingReasonCategory: {
          value: "",
          flag: false,
          hasError: false,
        },
        comingReasonCode: {
          value: "",
          flag: false,
          hasError: false,
        },
        etcContents: {
          value: "",
          flag: false,
          hasError: false,
        },
      },
      transContent: "",
    };
  },
  components: {
    AppHeader,
    AppSidebar,
    TabHeader,
    AddPopup,
  },
  computed: {
    ...mapGetters([
      "getComingTell",
      "getVisitList",
      "getTelDataCarry",
      "GET_CHECKAGREEMENT",
      "GET_USERINFO_LIST",
    ]),
    ...mapState(["checkPopup"]),
  },
  methods: {
    ...mapActions(["VISIT_LIST", "TEL_RESERVATION", "FETCH_USER_DATA"]),
    ...mapMutations(["SET_POPUP", "SET_TEL_RESERVATION_CARRY"]),
    updateInput(e) {
      this.$emit("input", e.target.checked);
    },
    goComing() {
      const telData = {
        userName: this.form.userName.value,
        tel: this.form.tel.value,
        visitPathCode: this.form.visitPathCode.value,
        requestContents: this.form.requestContents.value,
        checkAgreements: this.GET_CHECKAGREEMENT,
      };
      this.$store.commit("SET_TEL_RESERVATION_CARRY", telData);
      this.$router.push("/coming");
    },
    blurName() {
      this.form.userName.flag = false;
      this.checkName();
    },
    checkName() {
      if (this.form.userName.flag) return true;

      const name = this.form.userName.value.replace(/\s/gi, "");
      if (name === "") {
        this.form.userName.hasError = true;
        this.form.userName.errorTxt = "이름을 입력해주세요.";
        return false;
      }
      // const isHan = /^[가-힣]{2,5}$/
      // if (!isHan.test(name)) {
      //   this.form.userName.hasError = true
      //   this.form.userName.errorTxt = '2~5자리의 한글만 입력이 가능합니다.'
      //   return false
      // }
      this.form.userName.flag = true;
      this.form.userName.hasError = false;
      this.form.userName.errorTxt = "";
      return true;
    },
    blurTel() {
      this.form.tel.flag = false;
      this.checkTel();
    },
    checkTel() {
      if (this.form.tel.flag) return true;

      const tel = this.form.tel.value.replace(/\s/gi, "");
      if (tel === "") {
        this.form.tel.hasError = true;
        this.form.tel.errorTxt = "전화번호를 입력해주세요.";
        return false;
      }

      const isNumber = /^01(0|1|[6-9]?)-?([0-9]{3,4})-?([0-9]{4})$/;
      if (!isNumber.test(tel)) {
        this.form.tel.hasError = true;
        this.form.tel.errorTxt = "전화번호를 정확히 입력해주세요.";
        return false;
      }
      this.form.tel.flag = true;
      this.form.tel.hasError = false;
      this.form.tel.errorTxt = "";
      return true;
    },
    formatPhone(obj) {
      const number = obj.toString().replace(/[^0-9]/g, "");
      let phone = "";
      if (number.length < 4) {
        return number;
      }
      if (number.length < 7) {
        phone += number.substr(0, 3);
        phone += "-";
        phone += number.substr(3);
      } else if (number.length < 11) {
        phone += number.substr(0, 3);
        phone += "-";
        phone += number.substr(3, 3);
        phone += "-";
        phone += number.substr(6);
      } else {
        phone += number.substr(0, 3);
        phone += "-";
        phone += number.substr(3, 4);
        phone += "-";
        phone += number.substr(7);
      }
      return phone;
    },
    formatPhoneNumber(obj) {
      this.form.tel.value = this.formatPhone(obj);
    },
    blurText() {
      this.form.requestContents.flag = false;
      this.checkText();
    },
    checkText() {
      if (this.form.requestContents.flag) return true;

      const text = this.form.requestContents.value.trim();
      if (text === "") {
        this.form.requestContents.hasError = true;
        this.form.requestContents.errorTxt = "요청사항을 입력해주세요.";
        return false;
      }
      /*  */
      this.form.requestContents.flag = true;
      this.form.requestContents.hasError = false;
      this.form.requestContents.errorTxt = "";
      return true;
    },
    checkAll() {
      return !!(
        this.form.userName.flag &&
        this.form.tel.flag &&
        this.form.requestContents.flag
      );
    },
    getTelDataFetch() {
      console.log("데이터좀 보자", this.getComingTell);
      if (this.getComingTell.userName !== "") {
        const userName = this.getComingTell.userName;
        this.form.userName.value = userName;
        if (this.checkName()) {
          this.form.userName.flag = true;
        } else {
          this.form.userName.flag = false;
        }
      }
      if (this.getComingTell.tel !== "") {
        const tel = this.getComingTell.tel;
        this.form.tel.value = tel;
        if (this.checkTel()) {
          this.form.tel.flag = true;
        } else {
          this.form.tel.flag = false;
        }
      }
      if (this.getComingTell.requestContents !== "") {
        const requestContents = this.getComingTell.requestContents;
        this.form.requestContents.value = requestContents;
        this.form.requestContents.flag = true;
      }
      if (this.getComingTell.visitPathCode !== "") {
        const visitPathCode = this.getComingTell.visitPathCode;
        this.form.visitPathCode.value = visitPathCode;
        this.form.visitPathCode.flag = true;
      }
    },
    submitForm() {
      if (!this.checkAll()) {
        const name = this.form.userName.value.replace(/\s/gi, "");
        if (name === "") {
          this.form.userName.hasError = true;
          this.form.userName.errorTxt = "이름을 입력해주세요.";
          return false;
        }
        const tel = this.form.tel.value.replace(/\s/gi, "");
        if (tel === "") {
          this.form.tel.hasError = true;
          this.form.tel.errorTxt = "전화번호를 입력해주세요.";
          return false;
        }
        if (
          this.getComingTell.comingReasonCategory === "" ||
          this.getComingTell.comingReasonCode === ""
        ) {
          this.form.visitPathCode.hasError = true;
          this.form.visitPathCode.errorTxt = "내원사유를 선택해주세요.";
          return false;
        }
        const text = this.form.requestContents.value.trim();
        if (text === "") {
          this.form.requestContents.hasError = true;
          this.form.requestContents.errorTxt = "요청사항을 입력해주세요.";
          return false;
        }
        this.popupSet.content = "입력한 정보를 다시 확인해주세요.";
        this.SET_POPUP(true);
      } else {
        this.formAction();
      }
    },
    async formAction() {
      if (
        this.getComingTell.comingReasonCategory === "" ||
        this.getComingTell.comingReasonCode === ""
      ) {
        this.SET_POPUP(true);
        this.popupSet.content = "내원사유를 선택해주세요.";
        return false;
      }

      if (this.form.visitPathCode.value.length <= 0) {
        this.SET_POPUP(true);
        this.popupSet.content = "방문경로를 선택해주세요.";
        return false;
      }
      try {
        const telData = {
          userName: this.form.userName.value.replace(/\s/gi, ""),
          tel: this.form.tel.value.replace(/\s/gi, ""),
          requestContents: this.form.requestContents.value.trim(),
          visitPathCode: this.form.visitPathCode.value,
          comingReasonCategory: this.getComingTell.comingReasonCategory,
          comingReasonCode: this.getComingTell.comingReasonCode,
          etcContents: this.getComingTell.etcContents,
          checkAgreements: this.GET_CHECKAGREEMENT,
          etc: this.getComingTell.etc,
          etcReason: this.getComingTell.etcReason,
        };
        const IsType = typeof this.form.userName.value;
        console.log("타입검증", IsType);
        await this.TEL_RESERVATION(telData).then(() => {
          this.popupSet.content = "전화상담예약 신청이 완료되었습니다.";
          this.popupSet.count = "another";
          this.popupSet.nextLink = "/";
          this.popupSet.closeType = "action";
          this.popupSet.closeLink = "/";
          this.SET_POPUP(true);
        });
      } catch (error) {
        console.log('error :', error);
        console.log("전화상담 신청 API에서 에러남");
        if (error.status !== 401) {
          this.SET_POPUP(true);
          this.popupSet.content = errorParser.parse(error);
        } else {
          await this.$router.push("/login");
        }
      } finally {
        this.initForm();
      }
    },
    initForm() {
      console.log("form 초기화");
      this.form.userName.value = "";
      this.form.tel.value = "";
      this.form.requestContents.value = "";
      this.form.visitPathCode.value = "";
      this.getComingTell.userName = "";
      this.getComingTell.tel = "";
      this.getComingTell.requestContents = "";
      this.getComingTell.visitPathCode = "";
      this.getComingTell.comingReasonCategory = "";
      this.getComingTell.comingReasonCode = "";
      this.getComingTell.etcContents = "";
      this.getComingTell.etc = "";
      this.getComingTell.etcReason = "";
      this.getTelDataFetch();
    },
    async visitListAct() {
      try {
        this.VISIT_LIST().then(() => {});
      } catch (error) {
        console.log('error :', error);
        console.log("내원사유조회 API에서 에러남");
        if (error.status !== 401) {
          this.SET_POPUP(true);
          this.popupSet.content = errorParser.parse(error);
        } else {
          await this.$router.push("/login");
        }
      }
    },
    fetchData() {
      const agree = this.GET_CHECKAGREEMENT;
      console.log("agree: ", agree);
      if (agree === false) {
        this.$router.push("/telReservation_step1");
      }
      this.visitListAct();
      if (
        this.getComingTell.userName !== "" ||
        this.getComingTell.tel !== "" ||
        this.getComingTell.requestContents !== "" ||
        this.getComingTell.visitPathCode.length !== 0
      ) {
        this.getTelDataFetch();
      } else if (getCookie("token") !== undefined) {
        this.fetchUserInfo();
      }
    },
    storeUserInfo() {
      this.form.userName.value = this.GET_USERINFO_LIST.userName;
      this.form.tel.value = this.GET_USERINFO_LIST.tel;
      document.getElementById("nameStored").setAttribute("readonly", true);
      document.getElementById("telStored").setAttribute("readonly", true);
    },
    async fetchUserInfo() {
      try {
        this.FETCH_USER_DATA().then(() => this.storeUserInfo());
      } catch (error) {
        if (error.status !== 401) {
          this.SET_POPUP(true);
          this.popupSet.content = errorParser.parse(error);
        } else {
          await this.$router.push("/login");
        }
      }
    },
  },
  created() {
    this.fetchData();
    if (this.getComingTell.comingReasonCode !== "") {
      this.comingValue = true;
      if (this.getComingTell.content === "") {
        this.transContent = "기타사유";
      } else {
        this.transContent = this.getComingTell.content;
      }
      console.log("찍어줘", this.getComingTell);
    } else {
      this.comingValue = false;
    }
  },
  mounted() {
    if (getCookie("token") !== undefined) {
      document.getElementById("nameStored").readOnly = true;
      document.getElementById("telStored").readOnly = true;
    }
  },
  beforeDestroy() {
    this.SET_POPUP(false);
    this.initForm();
  },
};
</script>

<style lang="scss" scoped>
</style>
